import { rem } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  display: flex;
  margin-left: ${rem(8)};
  margin-right: ${rem(8)};
`;

const Destination = styled.div`
  display: flex;
  align-items: center;
  font-size: ${rem(24)};
  font-weight: 500;
  line-height: 1.17;
  letter-spacing: 0.2px;
  width: 100%;
  flex-wrap: wrap;
`;

const DestinationFromTo = props => {
  const { from, to, font, type } = props;
  return (
    <Destination>
      <div style={{ fontSize: font }}>{from}</div>
      <StyledIcon
        name={type === 'R' ? 'arrowToSides' : 'arrow-with-bullet'}
        size="l"
        primary
      />
      <div style={{ fontSize: font }}>{to}</div>
    </Destination>
  );
};

DestinationFromTo.propTypes = {
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  font: PropTypes.number,
  type: PropTypes.string,
};

DestinationFromTo.defaultProps = {
  font: 24,
  type: null,
};

export default DestinationFromTo;



// WEBPACK FOOTER //
// ./src/components/DestinationFromTo/index.js